module.exports = {
      id: "google-plain-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#google-plain",
      toString: function () {
        return this.url;
      }
    }